import { render, staticRenderFns } from "./createProject.vue?vue&type=template&id=58e01532&scoped=true"
import script from "./createProject.vue?vue&type=script&lang=js"
export * from "./createProject.vue?vue&type=script&lang=js"
import style0 from "./createProject.vue?vue&type=style&index=0&id=58e01532&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e01532",
  null
  
)

export default component.exports